import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import RobotTrack from '@components/Dashboard/RobotTrackmap';
import DashboardMenuBar from '@components/Dashboard/DashboardMenuBar';
import Profile from '@components/Dashboard/Profile';
import NftMinting from '@components/NftMinting';
import BotStatus from '@components/Dashboard/BotStatus';
import MenuOptions from '@components/Dashboard/MenuOptions';
import PurchaseTimeCredit from '@components/Modal/PurchaseTimeCredit';
import NoBotInfo from '@components/Modal/NoBotInfo';
import { getBotDetails } from '@services/api';
import * as actionTypes from '@redux/actionTypes';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '@context';
import ProfileModel from '@components/Dashboard/ProfileModel';
import _ from 'lodash';

const Dashboard = () => {
    const dispatch = useDispatch();
    const { setNoBotInfoPopUp, noBotInfoPopUp } = useAuth();
    const user = useSelector((state) => state.setUserDetails.user);
    const isBuyTcOpen = useSelector((state) => state.buyTc.buyTc);
    const isBuyNft = useSelector((state) => state.buyTc.isBuyNft);
    const profileModel = useSelector((state) => state.loadingSpinner.profileModel);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        botdetail();
        const interval = setInterval(() => botdetail(), 1000 * 60 * 0.5);
        return () => clearInterval(interval);
    }, []);

    const botdetail = async () => {
        const allBotsData = await getBotDetails();
        if (allBotsData) {
            const allBots = await _.sortBy(allBotsData, ['id']);
            if (allBots) {
                dispatch({
                    type: actionTypes.ALL_BOT,
                    payload: allBots
                });
                if (allBots?.length <= 0 && user?.kyc_id) {
                    setNoBotInfoPopUp(true);
                }
            }
        }
    };

    const closeTcPop = () => {
        dispatch({
            type: actionTypes.BUY_TC,
            payload: false
        });
    };

    const closeBuyNftModel = () => {
        dispatch({
            type: actionTypes.IS_BUY_NFT,
            payload: false
        });
    };

    const closeBotInfoPop = () => {
        setNoBotInfoPopUp(false);
    };

    const closeProfileModelHandler = () => {
        dispatch({
            type: actionTypes.PROFILE_MODEL,
            payload: false
        });
    };

    return (
        <div className='w-full h-full bg-[#f6f6f6] bg-[url("../images/map-bg.png")] bg-[100%_100%] bg-auto'>
            <div className="absolute left-0 top-0 right-0 bottom-0 w-full h-full">
                <RobotTrack />
            </div>
            <div className="absolute bottom-[26px] left-[26px]">
                <Profile />
            </div>
            <div className="absolute top-[26px] left-[50%] -translate-x-1/2">
                <DashboardMenuBar />
            </div>
            <div className="absolute right-[24px] top-[24px]">
                <BotStatus />
            </div>
            <div className="absolute bottom-[26px] left-[50%] -translate-x-1/2">
                <MenuOptions
                    setSelectedOption={setSelectedOption}
                    selectedOption={selectedOption}
                />
            </div>
            <Modal
                isOpen={isBuyTcOpen}
                ariaHideApp={false}
                className="mymodal"
                onRequestClose={closeTcPop}
            >
                <PurchaseTimeCredit />
            </Modal>
            <Modal
                isOpen={isBuyNft}
                ariaHideApp={false}
                className="mymodal"
                onRequestClose={closeBuyNftModel}
            >
                <NftMinting />
            </Modal>
            <Modal
                isOpen={noBotInfoPopUp}
                ariaHideApp={false}
                className="mymodal"
                onRequestClose={closeBotInfoPop}
            >
                <NoBotInfo />
            </Modal>
            <Modal
                isOpen={profileModel}
                ariaHideApp={false}
                className="absolute w-screen h-screen opacity-[0.85] bg-[#000] backdrop-filter"
                onRequestClose={closeProfileModelHandler}
            >
                <ProfileModel
                    closeProfileModelHandler={closeProfileModelHandler}
                    setSelectedOption={setSelectedOption}
                />
            </Modal>
        </div>
    );
};

export default Dashboard;